export enum TRIAL_SHOW_CASE_PAGES {
  HOME = 'home',
  CLASSROOMS = 'classrooms',
  CHANNEL = 'channel',
  NOTEBOOKS = 'notebooks',
  CLASSROOM = 'classroom',
}
